export const newProductFields = {
    productId: null,
    reference: '',
    price: 0,
    count: 1,
    allowCount: 0,
    squaremeters: 0,
    color: {
        id: '',
        poedernr: '',
        ralnr: '',
        raltype: '',
    },
    note: '',
    flowId: null,
    externUrl: '',
    linkToProductId: '',
};

export const height250ProductTypes = ['4', '5', '30', '39'];

export const dataTypes = {
    boolean: 1,
    int: 2,
    string: 3,
    options: 4,
    double: 5,
    table: 6,
    textarea: 7,
    popup: 8,
    multiselect: 9,
};

export const errorCodeTranslations = {
    'addAttachmentFromProsite.missingCaseID': 'Dossier ID ontbreekt',
    'addAttachmentFromProsite.noDirectory': 'Map ontbreekt',
    'documentsCreateExternal.missingAttribute': 'Heeft geen',
    'documentsCreateExternal.missingAttribute': 'Heeft meer dan één',
    'documentsCreateExternal.error': 'Serverfout',
    'documentsSyncFromOrder.invalid': 'Validatiefout',
    'documentsByOrder.invalid': 'Validatiefout',
    'documentsCreateExternal.invalid': 'Validatiefout',
};

export function getErrorText(errorData) {
    const error =
        errorData &&
        errorData.response &&
        errorData.response.data &&
        errorData.response.data.data
            ? errorData.response.data.data
            : null;
    const errorCode = error && error.code ? error.code : null;
    const description = error && error.description ? error.description : null;

    let errorMessage = errorCodeTranslations[errorCode] || errorCode;
    if (description) {
        errorMessage += '\n\n' + description;
    }
    return errorMessage;
}
